module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8771556be854985a93e479eecb02fad7.png";